import SUBROUTES from '../subroutes'
import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {getMyStokkeLabels} from '../../../utils/site-utils'
import useOcapiSite from '../../../hooks/useOcapiSite'
import {useCurrentCustomer} from '../../../hooks/use-current-customer'

const useMyStokkeSubroutes = () => {
    const {myStokkeConfig} = useOcapiSite()
    const {formatMessage} = useIntl()
    const {isD2BCustomer} = useCurrentCustomer().data

    return useMemo(
        () =>
            SUBROUTES.map((route) => {
                const routeConfig = myStokkeConfig[route.configId]
                if (routeConfig) {
                    const config = {
                        ...routeConfig
                    }
                    config.headline = getMyStokkeLabels(
                        routeConfig?.id,
                        'headline',
                        formatMessage,
                        isD2BCustomer
                    )
                    config.subline = getMyStokkeLabels(
                        routeConfig?.id,
                        'subline',
                        formatMessage,
                        isD2BCustomer
                    )
                    return {
                        ...route,
                        config
                    }
                }
                return {
                    ...route,
                    config: routeConfig
                }
            }),
        [myStokkeConfig, formatMessage, isD2BCustomer]
    )
}

export default useMyStokkeSubroutes
